import React, { useState } from "react";
import RevoPatientInfo1 from "./RevoPatientInfo1";
import Submit from "../pages/submit/Submit";
import MuiStepper from "../components/stepper/MuiSteper";
import TFRevoStandardMeasurement from "../pages/patientMeasurement/TFRevoStandardMeasurement";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import DefinitiveReview from "./DefinitiveReview";

const TFDefinitive = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);

  const handleNext = () => {
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };
  const handleBack = () => {
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClickOpen = (name) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const formData = [
    {
      id: 1,
      name: "Patient Information",
      innerSteps: [
        { id: 1, name: "Patient Info", isActive: true },
        { id: 3, name: "Amputation Side", isActive: true },
        { id: 4, name: "K Level", isActive: true },
      ],
      formContent: (
        <RevoPatientInfo1
          setActiveInnerStep={setActiveInnerStep}
          handleNext={handleNext}
          handleBack={handleBack}
          formTypeId={10}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 2,
      name: "Product Measurement",
      innerSteps: [
        { id: 2, name: "Socket Material", isActive: true },
        { id: 3, name: "Lock Options", isActive: true },
        { id: 5, name: "Delivery Date", isActive: true },
        { id: 6, name: "Notes", isActive: true },
      ],
      formContent: (
        <TFRevoStandardMeasurement
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={10}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 4,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={10}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 5,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={10}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 6,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <DefinitiveReview
          formTypeId={10}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="WillowWood Core™ TF with RevoFit"
        />
      ),
    },

    {
      id: 7,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);

  return (
    <div>
      <div>
        <MuiStepper
          data={formData}
          innerStep={activeInnerStep}
          setInnerStep={setActiveInnerStep}
          setActiveOuterStep={setActiveOuterStep}
          activeOuterStep={activeOuterStep}
          formName="WillowWood Core™ TF with RevoFit"
          totalSteps={totalIds}
        />
      </div>
    </div>
  );
};

export default TFDefinitive;
